export const APPLICATION_NAME = 'Product Support';
